import { RelevosHistoryDto, RelevosHistoryModel } from '../../modules/History/model/RelevosHistoryModel';
import { MoneyAmount } from '../../utils/money';

export const dtoToRelevosHistoryModel = (dto: RelevosHistoryDto): RelevosHistoryModel => {
  return {
    ...dto,
    deposit: dto.deposit
      ? {
          ...dto.deposit,
          amount: MoneyAmount.fromMinUnits(dto.deposit.amount),
        }
      : undefined,
  };
};
